import React from "react";
import className from "../../../shared/className";
import { observer } from "mobx-react";
import PatientItem from "../../../shared/Patient/PatientItem";

export default observer(function PatientListItem({
  patient,
  specifics,
  draggedPatient,
  surveilStore,
  dragStart,
  dragEnter,
  onDrop,
  onDragEnd,
  i,
  module,
}) {
  const patientIsActive = patient.status === "active" && !patient.isEmptyBed;
  return (
    <div
      {...className({
        "patient-list-item": true,
        dragged: patient === draggedPatient,
        outside: i >= surveilStore.layout,
        patientDrag: true,
      })}
      draggable
      onDragStart={() => dragStart(patient)}
      onDragEnter={() => dragEnter(patient)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <PatientItem
        patientIsActive={patientIsActive}
        showPHI={surveilStore.showPHI}
        patient={patient}
        specifics={specifics}
        module={module}
      />
    </div>
  );
});
